import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import RichTextEditor from 'Components/UI/RichTextEditor';

const metaOverrideSet = buildFacetDesignOverride()
  .override({ hint: 'usd' }, { _customProps: { fullWidth: true } }, overrideReadOnly)
  .override({ hint: 'percent' }, { _customProps: { fullWidth: true } }, overrideReadOnly)
  .override({ hint: 'richtext', readonly: false }, {
    _component: () => RichTextEditor,
  }, overrideReadOnly);

export default metaOverrideSet;
